module.exports = __webpack_public_path__ + "static/ideas-logo-c4c68633cf913c0672e68780fd5b7ea2.svg";